import { render, staticRenderFns } from "./SubMenuSection.vue?vue&type=template&id=04e2e7bd&scoped=true&"
import script from "./SubMenuSection.vue?vue&type=script&lang=ts&"
export * from "./SubMenuSection.vue?vue&type=script&lang=ts&"
import style0 from "./SubMenuSection.vue?vue&type=style&index=0&id=04e2e7bd&scoped=true&lang=scss&"
import style1 from "./SubMenuSection.vue?vue&type=style&index=1&id=04e2e7bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2e7bd",
  null
  
)

export default component.exports